import { NgModule } from 'ng-metadata/core';
import { PassportTypeDropComponent } from './passport-type-drop.component';


@NgModule({
  declarations: [
    PassportTypeDropComponent,
  ],
})
export class PassportTypeDropModule { }



// WEBPACK FOOTER //
// ./resources/assets/js/common/passport-type-drop/passport-type-drop.module.ts